// Arabic labels for the canonical English country / service tag strings
// returned by /api/advisors/filters/options. We keep the API values in English
// (so filters remain sortable + indexable), but display them translated when
// the UI language is AR.

export const COUNTRY_AR = {
  "Afghanistan":"أفغانستان","Albania":"ألبانيا","Algeria":"الجزائر","Andorra":"أندورا",
  "Angola":"أنغولا","Antigua and Barbuda":"أنتيغوا وباربودا","Argentina":"الأرجنتين",
  "Armenia":"أرمينيا","Australia":"أستراليا","Austria":"النمسا","Azerbaijan":"أذربيجان",
  "Bahamas":"الباهاما","Bahrain":"البحرين","Bangladesh":"بنغلاديش","Barbados":"بربادوس",
  "Belarus":"بيلاروسيا","Belgium":"بلجيكا","Belize":"بليز","Benin":"بنين","Bhutan":"بوتان",
  "Bolivia":"بوليفيا","Bosnia and Herzegovina":"البوسنة والهرسك","Botswana":"بوتسوانا",
  "Brazil":"البرازيل","Brunei":"بروناي","Bulgaria":"بلغاريا","Burkina Faso":"بوركينا فاسو",
  "Burundi":"بوروندي","Cambodia":"كمبوديا","Cameroon":"الكاميرون","Canada":"كندا",
  "Cape Verde":"الرأس الأخضر","Central African Republic":"جمهورية إفريقيا الوسطى",
  "Chad":"تشاد","Chile":"تشيلي","China":"الصين","Colombia":"كولومبيا","Comoros":"جزر القمر",
  "Congo (Brazzaville)":"الكونغو (برازافيل)","Congo (Kinshasa)":"الكونغو (كينشاسا)",
  "Costa Rica":"كوستاريكا","Côte d'Ivoire":"ساحل العاج","Croatia":"كرواتيا","Cuba":"كوبا",
  "Cyprus":"قبرص","Czech Republic":"جمهورية التشيك","Denmark":"الدنمارك","Djibouti":"جيبوتي",
  "Dominica":"دومينيكا","Dominican Republic":"جمهورية الدومينيكان","Ecuador":"الإكوادور",
  "Egypt":"مصر","El Salvador":"السلفادور","Equatorial Guinea":"غينيا الاستوائية",
  "Eritrea":"إريتريا","Estonia":"إستونيا","Eswatini":"إسواتيني","Ethiopia":"إثيوبيا",
  "Fiji":"فيجي","Finland":"فنلندا","France":"فرنسا","Gabon":"الغابون","Gambia":"غامبيا",
  "Georgia":"جورجيا","Germany":"ألمانيا","Ghana":"غانا","Greece":"اليونان","Grenada":"غرينادا",
  "Guatemala":"غواتيمالا","Guinea":"غينيا","Guinea-Bissau":"غينيا بيساو","Guyana":"غيانا",
  "Haiti":"هايتي","Honduras":"هندوراس","Hungary":"المجر","Iceland":"آيسلندا","India":"الهند",
  "Indonesia":"إندونيسيا","Iran":"إيران","Iraq":"العراق","Ireland":"أيرلندا","Israel":"إسرائيل",
  "Italy":"إيطاليا","Jamaica":"جامايكا","Japan":"اليابان","Jordan":"الأردن",
  "Kazakhstan":"كازاخستان","Kenya":"كينيا","Kiribati":"كيريباتي","Kuwait":"الكويت",
  "Kyrgyzstan":"قيرغيزستان","Laos":"لاوس","Latvia":"لاتفيا","Lebanon":"لبنان","Lesotho":"ليسوتو",
  "Liberia":"ليبيريا","Libya":"ليبيا","Liechtenstein":"ليختنشتاين","Lithuania":"ليتوانيا",
  "Luxembourg":"لوكسمبورغ","Madagascar":"مدغشقر","Malawi":"مالاوي","Malaysia":"ماليزيا",
  "Maldives":"المالديف","Mali":"مالي","Malta":"مالطا","Marshall Islands":"جزر مارشال",
  "Mauritania":"موريتانيا","Mauritius":"موريشيوس","Mexico":"المكسيك","Micronesia":"ميكرونيزيا",
  "Moldova":"مولدوفا","Monaco":"موناكو","Mongolia":"منغوليا","Montenegro":"الجبل الأسود",
  "Morocco":"المغرب","Mozambique":"موزمبيق","Myanmar":"ميانمار","Namibia":"ناميبيا",
  "Nauru":"ناورو","Nepal":"نيبال","Netherlands":"هولندا","New Zealand":"نيوزيلندا",
  "Nicaragua":"نيكاراغوا","Niger":"النيجر","Nigeria":"نيجيريا","North Korea":"كوريا الشمالية",
  "North Macedonia":"مقدونيا الشمالية","Norway":"النرويج","Oman":"عمان","Pakistan":"باكستان",
  "Palau":"بالاو","Palestine":"فلسطين","Panama":"بنما","Papua New Guinea":"بابوا غينيا الجديدة",
  "Paraguay":"باراغواي","Peru":"بيرو","Philippines":"الفلبين","Poland":"بولندا",
  "Portugal":"البرتغال","Qatar":"قطر","Romania":"رومانيا","Russia":"روسيا","Rwanda":"رواندا",
  "Saint Kitts and Nevis":"سانت كيتس ونيفيس","Saint Lucia":"سانت لوسيا",
  "Saint Vincent and the Grenadines":"سانت فينسنت والغرينادين","Samoa":"ساموا",
  "San Marino":"سان مارينو","São Tomé and Príncipe":"ساو تومي وبرينسيبي",
  "Saudi Arabia":"المملكة العربية السعودية","Senegal":"السنغال","Serbia":"صربيا",
  "Seychelles":"سيشل","Sierra Leone":"سيراليون","Singapore":"سنغافورة","Slovakia":"سلوفاكيا",
  "Slovenia":"سلوفينيا","Solomon Islands":"جزر سليمان","Somalia":"الصومال",
  "South Africa":"جنوب إفريقيا","South Korea":"كوريا الجنوبية","South Sudan":"جنوب السودان",
  "Spain":"إسبانيا","Sri Lanka":"سريلانكا","Sudan":"السودان","Suriname":"سورينام",
  "Sweden":"السويد","Switzerland":"سويسرا","Syria":"سوريا","Taiwan":"تايوان",
  "Tajikistan":"طاجيكستان","Tanzania":"تنزانيا","Thailand":"تايلاند","Timor-Leste":"تيمور الشرقية",
  "Togo":"توغو","Tonga":"تونغا","Trinidad and Tobago":"ترينيداد وتوباغو","Tunisia":"تونس",
  "Turkey":"تركيا","Turkmenistan":"تركمانستان","Tuvalu":"توفالو","Uganda":"أوغندا",
  "Ukraine":"أوكرانيا","United Arab Emirates":"الإمارات العربية المتحدة",
  "United Kingdom":"المملكة المتحدة","United States":"الولايات المتحدة","Uruguay":"الأوروغواي",
  "Uzbekistan":"أوزبكستان","Vanuatu":"فانواتو","Vatican City":"الفاتيكان","Venezuela":"فنزويلا",
  "Vietnam":"فيتنام","Yemen":"اليمن","Zambia":"زامبيا","Zimbabwe":"زيمبابوي",
};

export const SERVICE_TAG_AR = {
  "GHG Accounting":          "محاسبة الغازات الدفيئة",
  "GRI Reporting":           "تقارير GRI",
  "ISSB / IFRS S1 S2":       "ISSB / IFRS S1 S2",
  "TCFD / Climate Risk":     "TCFD / مخاطر المناخ",
  "Materiality Assessment":  "تقييم الأهمية النسبية",
  "Supply-chain Due Diligence": "العناية الواجبة لسلسلة التوريد",
  "Audit & Assurance":       "التدقيق والتأكيد",
  "ESG Strategy":            "استراتيجية ESG",
  "ESG Training":            "تدريب ESG",
  "Carbon Footprint":        "البصمة الكربونية",
  "Sustainability Reporting":"تقارير الاستدامة",
  "Renewable Energy":        "الطاقة المتجددة",
  "Circular Economy":        "الاقتصاد الدائري",
  "Biodiversity":            "التنوع البيولوجي",
  "Water Stewardship":       "إدارة المياه",
  "DEI & Human Capital":     "التنوع والشمول ورأس المال البشري",
  "Governance Advisory":     "استشارات الحوكمة",
};

export function countryLabel(name, lang) {
  if (!name) return "";
  if (lang === "ar") return COUNTRY_AR[name] || name;
  return name;
}

export function serviceTagLabel(name, lang) {
  if (!name) return "";
  if (lang === "ar") return SERVICE_TAG_AR[name] || name;
  return name;
}
